import React from 'react'
import { DatatableRow, DatatableCell } from '../../atoms/Datatable/Datatable'
import ProdottoInfo from '../../molecules/ProdottoInfo/ProdottoInfo'
import { priceNotation } from '../../../utils/safe'
import _ from 'lodash'
import { Trans } from '../../atoms'

export const DataTableCreaOffertaCols = {
  prodotto: { label: <Trans chiave="Descrizione" />, mobileCols: 12 },
  prezzoPezzo: { label: <Trans chiave="Prezzo/Pz" />, width: '100px', mobileCols: 5 },
  quantita: { label: <Trans chiave="Quantità" />, width: '100px', mobileCols: 7 },
  totale: { label: <Trans chiave="Totale" />, width: '100px', mobileCols: 5 },
  margine: { label: <Trans chiave="Margine" />, width: '200px', mobileCols: 5 },
  totale_quotazione: { label: <Trans chiave="Totale quotazione" />, width: '170px', mobileCols: 12 },
}

const DataTableRowCreaOfferta = ({
  riga,
  isPrenotato,
  articolo,
  quantita,
  even,
  totaleQuotazione,
  margineInput,
  preview,
  creaOfferta,
  rigaId,
  personalizzazioneId,
}) => {
  const prodottoInfoData = {
    image: articolo.main_image,
    thumb_image: articolo.thumb_image,
    codice: articolo.codice,
    titolo: articolo.titolo,
    url: articolo.url,
    colore: articolo.colore?.nome,
    taglia: articolo.taglia?.nome,
  }

  const cols = preview ? _.omit?.(DataTableCreaOffertaCols, ['totale']) : DataTableCreaOffertaCols
  return (
    <>
      <DatatableRow even={even} className="datatable-row-cart">
        <DatatableCell col={cols.prodotto}>
          <ProdottoInfo prodotto={prodottoInfoData} isPrenotato={isPrenotato} />
        </DatatableCell>

        {preview
          ? null
          : creaOfferta?.tipoMarkup !== 'sul_totale' && (
              <DatatableCell col={cols.prezzoPezzo} className="datatable-row-cart__bspaced-cell">
                {priceNotation(riga?.prezzo_unitario_netto, 3)} €
              </DatatableCell>
            )}
        <DatatableCell col={cols.quantita} className="datatable-row-cart__bspaced-cell">
          <div className="quantity-edit">
            <span className="quantity-edit__value">{quantita}</span>
          </div>
        </DatatableCell>
        {!preview && creaOfferta?.tipoMarkup !== 'sul_totale' && (
          <DatatableCell col={cols.totale} className="datatable-row-cart__bspaced-cell">
            <b>{priceNotation(riga?.prezzo_totale_netto, 3)} €</b>
          </DatatableCell>
        )}
        {margineInput && (
          <>
            <DatatableCell col={cols.margine} className="datatable-row-cart__bspaced-cell">
              {margineInput?.({
                codice: prodottoInfoData?.codice,
                totale: riga?.prezzo_totale_netto,
                rigaId: rigaId,
                personalizzazioneId: personalizzazioneId,
              })}
            </DatatableCell>
            {!preview && (
              <DatatableCell
                col={cols.totale_quotazione}
                className="datatable-row-cart__bspaced-cell"
              >
                <b>{totaleQuotazione?.(prodottoInfoData?.codice + (personalizzazioneId ? `_${personalizzazioneId}` : ""))}</b>
              </DatatableCell>
            )}
          </>
        )}
        {preview && creaOfferta?.tipoMarkup !== 'sul_totale' && (
          <DatatableCell col={cols.totale_quotazione} className="datatable-row-cart__bspaced-cell">
            <b>{totaleQuotazione?.(prodottoInfoData?.codice + (personalizzazioneId ? `_${personalizzazioneId}` : ""))}</b>
          </DatatableCell>
        )}
      </DatatableRow>
    </>
  )
}

export default DataTableRowCreaOfferta
